
import { AuthService } from "@/services/auth-service";
import { PaymentService } from "@/services/payment-service";
import { HttpError } from "@/utils/services/http-error";
import Vue from "vue";
import { TranslateResult } from "vue-i18n";
import { Tier } from "@/utils/payments/tiers";

export default Vue.extend({
	data() {
		return {
			hasSubscription: true
		};
	},
	computed: {
		isEnterprise(): boolean {
			return AuthService.wfCompany.Tier == Tier.ENTERPRISE;
		},
		isProfPlus(): boolean {
			return AuthService.wfCompany.Tier == Tier.PROFPLUS;
		},
		daysLeft(): number {
			if (!AuthService.wfCompany) return 0;
			var d1 = AuthService.wfCompany.ActiveUntil;
			var diff = d1.getTime() - new Date().getTime();
			return Math.ceil((diff / (1000 * 3600 * 24)));
		},
		daysLeftMsg(): TranslateResult {
			let key = this.isEnterprise || this.isProfPlus ? "days-left-message-enterprise" : "days-left-message";
			return this.$ctc(key, this.daysLeft).toString();
		},
		show(): boolean {
			if (AuthService.wfCompany.Tier == Tier.FREE) return false;
			if (AuthService.wfCompany.isPermanentlyActive()) return false;
			if (this.hasSubscription) return false;
			if (this.daysLeft > 30) return false;
			if (AuthService.wfCompany.IsDemo) return false;
			return true;
		}
	},
	watch: {
		show: {
			immediate: true,
			handler() {
				this.$emit("show", this.show);
			}
		}
	},
	async created() {
		if (AuthService.wfCompany.isPermanentlyActive()) return;
		try {
			await PaymentService.getActiveSubscription();
			this.hasSubscription = true;
		} catch (err) {
			let e = err as HttpError;
			e.dontShow = true;
			this.hasSubscription = false;
		}
	},
	i18nEx: {
		componentPrefix: "components.common-RenewInfo"
	}
});
